import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ms-1"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["m-0 py-0", { 'btn btn-sm btn-primary': _ctx.cart_counter > 0 }])
  }, [
    _createVNode(_component_icon, { name: "SHOPPING_CART" }),
    (_ctx.cart_counter > 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.cart_counter), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}